import { HTTP } from "@/http-common";
import { getField, updateField } from "vuex-map-fields";
import { httpError } from "@/models/httpError";
import { Uploads } from "@/models/Uploads";
import { createHelpers } from "vuex-map-fields";

export const { mapFields: mapUploadFields } = createHelpers({
  getterType: `uploads/getField`,
  mutationType: `uploads/updateField`
});
export const { mapMultiRowFields: mapUploadMultiRowFields } = createHelpers({
  getterType: "uploads/getField",
  mutationType: "uploads/updateField"
});

const state = {
  rows: [],
  session: null
};

//getters

const getters = {
  getField
};

//Mutations
const mutations = {
  addRow(state) {
    state.rows.push(new Uploads());
  },
  clearRows(state) {
    if (typeof state.rows !== "object") state.rows = [];
    state.rows.length = 0;
    state.rows.push(new Uploads());
  },
  removeRow(state) {
    state.rows.pop();
  },
  setRows(state, upload) {
    state.rows.length = 0;
    state.rows = upload;
  },
  setSession(state, session) {
    state.session = session;
  },
  updateField
};

//ACTIONS
const actions = {
  reset({ commit }) {
    commit("clearRows");
  },

  populateUploads({ commit, dispatch, rootState }) {
    return new Promise((resolve, reject) => {
      let url = null;

      url = "GetDealerLogo/" + rootState.dealer.dealer.dealerID;

      let response = HTTP.get("Support/" + url);
      response
        .then(function(data) {
          if (data.status === 200) {
            commit("setRows", data.data);
          } else commit("setRows", []);
          dispatch(
            "message/setMessage",
            new httpError({ message: "Retrieved OK", httpStatus: 200 }),
            { root: true }
          );
          resolve(data.data);
          return;
        })
        .catch(function(err) {
          commit("setRows", []);
          dispatch(
            "message/setMessage",
            new httpError({ message: "Error" + err.message, httpStatus: 500 }),
            { root: true }
          );
          if (err.response.status == 401) {
            reject(401);
          }
          reject(err.response.status);
        });
    });
  },
  updateUploadsOnOrder({ commit, dispatch, rootState }, formData) {
    return new Promise((resolve, reject) => {
      let url = "";
      if (
        rootState.orders.rows[0].orderStatus == 1 &&
        rootState.orders.rows[0].orderGUID !== null
      ) {
        url = "UploadFilesByGuid/" + rootState.orders.rows[0].orderGUID;
      } else {
        url = "UploadFiles/" + rootState.orders.rows[0].orderID;
      }

      var response = HTTP.post("order/" + url, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
      response
        .then(data => {
          if (data.status == 200) {
            commit("setRows", data.data);
            commit("setSession", data.data.session);
            resolve(data.data);
          }
        })
        .catch(err => {
          dispatch(
            "message/setMessage",
            new httpError({ message: err.message, httpStatus: 500 }),
            { root: true }
          );
          reject(err);
        });
    });
  },

  async removeRows({ state, commit }, newVal) {
    //rowCount is the number of rows to finish with
    var oldVal = 0 || state.rows.length;
    var rows = [];
    for (var i = oldVal; i > newVal; i--) {
      rows.push(state.rows[i - 1]);
      commit("removeRow");
    }
    //try {
    //    var ipexts = await HTTP.delete('order/DeleteIPExtsFromOrder/' + rootState.orders.rows[0].orderID, { data: rows });
    //    return Promise.resolve(ipexts);

    //} catch (e) {
    //    return Promise.reject(err);
    //}
    return Promise.resolve();
  },

  getAttachment({ dispatch, rootState }, file) {
    return new Promise(reject => {
      var response = HTTP.post(
        "order/getAttachment/" + rootState.orders.rows[0].orderID,
        { filename: file.filename },
        {
          responseType: "blob"
        }
      );
      response
        .then(data => {
          const url = window.URL.createObjectURL(
            new Blob([data.data], { type: file.contentType })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", file.filename);
          document.body.appendChild(link);
          link.click();
        })

        .catch(err => {
          dispatch(
            "message/setMessage",
            new httpError({ message: err.message, httpStatus: 500 }),
            { root: true }
          );
          reject(err);
        });
    });
  },
  getExtension(fileName) {
    return fileName.substr(fileName.lastIndexOf(".") + 1, fileName.length - 1);
  },
  async deleteAttachment({ rootState, dispatch, commit }, fileGuid) {
    try {
      let data = await HTTP.delete(
        "order/RemoveAttachment/" + rootState.orders.rows[0].orderID,
        { data: { fileGuid: fileGuid } }
      );
      if (data.status == 200) {
        commit("setRows", data.data);
        commit("setSession", data.data.session);
        return new Promise.resolve(data.data);
      }
    } catch (error) {
      dispatch(
        "message/setMessage",
        new httpError({
          message: "Attachment not removed: " + error.message,
          httpStatus: 500
        }),
        { root: true }
      );
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
